module.exports = __webpack_public_path__ + "img/product_bg_new_04.24337d3.webp";